package com.vizio.redwolf.dms.homesetup

import com.vizio.redwolf.utils.Environment
import com.vizio.redwolf.utils.EnvironmentGroup
import com.vizio.redwolf.utils.HomeSetupEnvironmentConfig
import kotlin.js.JsExport

@JsExport
interface HomeSetupEnvironment : Environment {
    val host: String
    val envPath: String
    val jwtVoiceToken: String
    val jwtToken: String
    val apiKey: String
    val v2ApiKey: String
    val redirectUri: String
}

@JsExport
abstract class BaseHomeSetupEnvironment(override val host: String = "platform.vizio.com") : HomeSetupEnvironment

@JsExport
data class DevHomeSetupEnvironment(
    override val jwtToken: String,
    override val apiKey: String,
    override val v2ApiKey: String,
    override val envPath: String = "/dmsdev",
    override val jwtVoiceToken: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoiZG1zd2ViIiwic2NvcGUiOiJkbXMvc2VydmljZSJ9.6MTWnpC_XjG6TYYAWac1-ksTPGDqGUyiVsWMS3va_zc",
    override val redirectUri: String = "http://dev.dms.vizio.com"
) : BaseHomeSetupEnvironment()

@JsExport
data class StageHomeSetupEnvironment(
    override val jwtToken: String,
    override val apiKey: String,
    override val v2ApiKey: String,
    override val envPath: String = "/dmsstage",
    override val jwtVoiceToken: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoiZG1zd2ViIiwic2NvcGUiOiJkbXMvc2VydmljZSIsInN0YWdlIjoic3RhZ2UifQ.WOriSJSKidP5a5H8OqRkAaS5lARhxSH_ea-Fn8YNDvg",
    override val redirectUri: String = "http://stage.dms.vizio.com"
) : BaseHomeSetupEnvironment()

@JsExport
data class PreProdHomeSetupEnvironment(
    override val jwtToken: String,
    override val apiKey: String,
    override val v2ApiKey: String,
    override val envPath: String = "/dmsauthdev",
    override val jwtVoiceToken: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoicG9zdG1hbiIsInNjb3BlIjoiZG1zL3NlcnZpY2UifQ.F02xnHihM-pwqyssRIid9rWT4KqC-jZZN2MRBYEWNtI",
    override val redirectUri: String = "http://test.dms.vizio.com"
) : BaseHomeSetupEnvironment()

@JsExport
data class ProdHomeSetupEnvironment(
    override val jwtToken: String,
    override val apiKey: String,
    override val v2ApiKey: String,
    override val envPath: String = "/dms",
    override val jwtVoiceToken: String = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjaGFubmVsIjoiZG1zd2ViIiwic2NvcGUiOiJkbXMvc2VydmljZSIsInN0YWdlIjoicHJvZCJ9.DCjiCZ3W6kSlLa6OnbZF2pcq-345_TeDRKlWW5g6Auc",
    override val redirectUri: String = "https://dms.vizio.com"
) : BaseHomeSetupEnvironment()


fun chooseHomeSetupEnvironment(envConfig: HomeSetupEnvironmentConfig): HomeSetupEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdHomeSetupEnvironment(jwtToken = envConfig.dmsJwt, apiKey = envConfig.dmsApiKey, v2ApiKey = envConfig.dmsV2ApiKey)
        EnvironmentGroup.PREPROD -> PreProdHomeSetupEnvironment(jwtToken = envConfig.dmsJwt, apiKey = envConfig.dmsApiKey, v2ApiKey = envConfig.dmsV2ApiKey)
        EnvironmentGroup.STAGE -> StageHomeSetupEnvironment(jwtToken = envConfig.dmsJwt, apiKey = envConfig.dmsApiKey, v2ApiKey = envConfig.dmsV2ApiKey)
        EnvironmentGroup.DEV -> DevHomeSetupEnvironment(jwtToken = envConfig.dmsJwt, apiKey = envConfig.dmsApiKey, v2ApiKey = envConfig.dmsV2ApiKey)
        EnvironmentGroup.TEST -> TODO("Test Environment for HomeSetup not defined!")
    }
}
